var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgViewIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 9,
  viewBox: "0 0 12 9"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 0c3.75 0 5.472 3.13 5.91 4.09l.044.114a.984.984 0 0 1-.043.705C11.47 5.87 9.75 9 6 9 2.25 9 .527 5.87.088 4.91a.984.984 0 0 1 0-.82C.53 3.13 2.25 0 6 0zm0 1.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0 1a2 2 0 1 1 0 4 2 2 0 0 1 0-4z",
  fill: "#191919",
  fillRule: "evenodd",
  fillOpacity: 0.6
})));

export default __webpack_public_path__ + "static/media/view-icon.8646128c.svg";
export { SvgViewIcon as ReactComponent };